import { useState, useEffect, useCallback } from "react";

export type TWindowSize = {
  width: number;
  height: number;
};

export const useWindowSize = () => {

  const [ windowSize, setWindowSize ] = useState<TWindowSize>({
    width: 0,
    height: 0,
  });

  const isWindowSizeAboveValue = useCallback((value: number): boolean => (
    value >= windowSize.width
  ), [ windowSize.width ]);

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    windowSize,
    isWindowSizeAboveValue,
  };
};
